import { getItem } from "utils/local-storage";

/**
 * Filters the menu based on authentication status and other conditions.
 * @param {Array} menu - The menu array to filter.
 * @param {string|null} token - The authentication token.
 * @returns {Array} - The filtered menu array.
 */
export const filteredMenu = (menu, token) => {
  const currentUser = getItem("current_user");
  const isAdmin = currentUser && currentUser.isAdmin === true;

  return menu.filter((item) => {
    if (item.isProtected && !token) {
      return false; // Hide protected items if the user is not authenticated
    }
    if (item.onlyNonAuth && token) {
      return false; // Hide items meant only for non-authenticated users if the user is logged in
    }
    if (item.requiresAdmin && !isAdmin) {
      return false; // Hide admin-only items if the user is not an admin
    }
    return true; // Show other items
  });
};
